import React from 'react';
import { observer } from 'mobx-react';
import { NikoPatientTemplateClinicalEditTemplate } from 'themes/application/niko-patient/components';
import { setCurrentView } from 'core/utils';
import { NikoPatientTemplateClinicalEditViewStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoPatientTemplateClinicalEditViewStore(rootStore, componentProps), 'nikoPatientTemplateClinicalEditViewStore')
@observer
class NikoPatientTemplateClinicalEdit extends React.Component {
    render() {
        return <NikoPatientTemplateClinicalEditTemplate {...this.props} />
    }
}

export default NikoPatientTemplateClinicalEdit;